import ArtemisMascotMark from './ArtemisMascotMark'

/**
 * Lockup horizontal: mascota + «Artemis» (Cormorant) + subtítulo.
 * Respeta `dark:` (sidebar / tema).
 */
export default function ArtemisWordmark({
  mascotSize = 32,
  showSubtitle = true,
  className = '',
}) {
  return (
    <div className={`flex items-center gap-2.5 min-w-0 ${className}`}>
      <ArtemisMascotMark size={mascotSize} className="flex-shrink-0 rounded-[11px]" />
      <div className="min-w-0 text-left">
        <div className="font-artemis text-[15px] font-semibold tracking-[0.04em] leading-tight truncate text-[#1a2535] dark:text-[#e8edf5]">
          Artemis
        </div>
        {showSubtitle ? (
          <div className="text-[10px] text-[#7a8fa6] tracking-[0.06em] mt-0.5 leading-tight">
            GESTIÓN VETERINARIA
          </div>
        ) : null}
      </div>
    </div>
  )
}
